import IMAGES from 'assets/images';
import { IAdditionalDocument } from 'core/utilities';
import React from 'react';
import { ProgressBar } from 'view/components/common';
import { DragAndDrop, MutedDragAndDropText, PreviewContainer, UploadComplete, UploadDocumentText } from './PreviewContent.styles';

interface IProps {
    document: IAdditionalDocument;
    dragOver: boolean;
    isUploadingOrDeleting: boolean;
    progress: number;
}

const PreviewContent: React.FC<IProps> = ({ document, dragOver, isUploadingOrDeleting, progress }) => {
    return (
        <PreviewContainer draggedOver={dragOver}>
            {!document.uploaded ? (
                <>
                    <DragAndDrop src={IMAGES.dragAndDrop} />
                    <UploadDocumentText>Drop files here</UploadDocumentText>
                    <MutedDragAndDropText>Or click to add files...</MutedDragAndDropText>
                    {isUploadingOrDeleting && <ProgressBar progress={progress}></ProgressBar>}
                </>
            ) : (
                <>
                    <UploadComplete src={IMAGES.uploadComplete} />
                    <UploadDocumentText>Upload complete!</UploadDocumentText>
                    <ProgressBar progress={100}></ProgressBar>
                </>
            )}
        </PreviewContainer>
    );
};

export default PreviewContent;
